var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: red;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 150,
    cy: 150,
    r: 150
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m150,78.41c39.37,0,71.59,32.05,71.59,71.59s-32.05,71.59-71.59,71.59-71.59-32.05-71.59-71.59,32.22-71.59,71.59-71.59m0-6.82c-43.3,0-78.41,35.11-78.41,78.41s35.11,78.41,78.41,78.41,78.41-35.11,78.41-78.41-35.11-78.41-78.41-78.41h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "122.73 189.2 189.2 148.3 122.73 110.8 122.73 189.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.5cbb43c0f732395c4c323a66cabe4a3c.svg";
export { ForwardRef as ReactComponent };